import React from 'react';
import CheckCircleIcon from '@material-ui/icons/CheckCircle';
import { StepIconProps } from '@material-ui/core/StepIcon';
import clsx from 'clsx';
import { useStepIconStyles } from './styles';

const StepIcon = (props: StepIconProps) => {
  const classes = useStepIconStyles();
  const { active, completed } = props;

  return (
    <div
      className={clsx(classes.root, {
        [classes.active]: active,
      })}
    >
      {completed ? (
        <div className={classes.completed}>
          <CheckCircleIcon />
        </div>
      ) : (
        <div className={classes.outerCircle}>
          <div className={classes.innerCircle}>
            <div className={classes.Circle} />
          </div>
        </div>
      )}
    </div>
  );
};

export default StepIcon;
